import classnames from 'classnames';
import { useMemo } from 'react';

import { isSpainPlatform, isUkPlatform } from '@/domains/core/settings/utils';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';
import { useQuantity } from '@/domains/productDiscovery/ProductPage/hooks/useQuantity';

import { Paypal4xLabel } from '../Paypal4xLabel/Paypal4xLabel';

import styles from './PaymentInformations.module.scss';

const MIN_PAYPAL_LATER = isUkPlatform() ? 80 : 100;
const MAX_PAYPAL_LATER = 2000;

export const PaymentInformations = () => {
  const { price } = useDetail();
  const quantity = useQuantity();
  const totalPrice = useMemo(() => {
    const amount = price?.primaryPrice.amountWithVat;
    return amount ? amount * quantity : 0;
  }, [price, quantity]);

  const showPaypalBanner =
    isSpainPlatform() &&
    totalPrice >= MIN_PAYPAL_LATER &&
    totalPrice <= MAX_PAYPAL_LATER;

  return (
    <>
      {showPaypalBanner && (
        <Paypal4xLabel
          className={classnames(
            styles.banner,
            styles.externallyControlledBanner,
          )}
          amount={totalPrice}
        />
      )}
    </>
  );
};

PaymentInformations.displayName = 'PaymentInformations';
